import React, {useContext, useReducer, useEffect} from 'react';
import { useChatContext } from 'stream-chat-react';
import { FixedSizeList } from 'react-window';
import Fuse from 'fuse.js';
import { Button, IconButton, Tooltip, Dialog,
  Box, Checkbox, Chip, Divider,
  InputAdornment, ListItem, ListItemButton, ListItemIcon,
  ListItemText, Typography, DialogActions, DialogContent,
  DialogTitle, Slide, TextField } from '@mui/material';
import { Share as ShareIcon, Clear as ClearIcon, Search as SearchIcon, Send as SendIcon, Warning as WarningIcon } from '@mui/icons-material';
import { GlobalContext } from '../../GlobalState';
import { getChannelName, getDirectMembers, getEpochLastMessageAt, sort_obj_lastMessageAt } from '../../utils';



const Transition = React.forwardRef((props, ref) => <Slide direction='down' ref={ref} {...props} />);

const initialState_modal = {
  open: false,
  data: { input: '', message: {}, channels_list: [], channels_filtered: [], selected: null, filter: '' },
  error: false
};
const reducer_modal = (state, action) => {
  switch (action.type) {
    case 'UPDATE':
      return { ...state, data: { ...state.data, ...action.payload } };
    case 'UPDATE-FILTER':
      let new_filter = state.data.filter === action.payload.filter ? '' : action.payload.filter;
      return { ...state, data: { ...state.data, filter: new_filter } };
    case 'ERROR': 
      return { ...state, error: true };
    case 'OPEN':
      return { ...initialState_modal, open: true, data: { ...state.data, ...action.payload } };
    case 'CLOSE': 
      return { ...initialState_modal };
    default:
      return state;
  }
};
export const MsgForwardModal = ({message}) => {
  const { globalState, setGlobalState } = useContext(GlobalContext);
  const { client, channel, setActiveChannel } = useChatContext();
  const [state_modal, dispatch_modal] = useReducer(reducer_modal, initialState_modal);
  
  useEffect(() => {
    if (state_modal.open === true) {
      try {
        let tmp_input = state_modal.data.input;
        let tmp_filter = state_modal.data.filter;
        let tmp_channelsArray = state_modal.data.channels_list.sort(sort_obj_lastMessageAt);
        if (tmp_filter !== '') tmp_channelsArray = tmp_channelsArray.filter(itc => itc.type === tmp_filter);
        if (tmp_input !== '') {
          const options = {
            includeScore: true,
            includeMatches: true,
            threshold: 0.2,
            keys: [ 'name' ]
          };
          const fuseInit = new Fuse(tmp_channelsArray, options);
          const fuseResult = fuseInit.search(tmp_input);
          tmp_channelsArray = fuseResult.map(res => res.item);
        }
        dispatch_modal({type: 'UPDATE', payload: {channels_filtered: tmp_channelsArray}});
      }
      catch (error) {
        console.log(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state_modal.open, state_modal.data.input, state_modal.data.filter])

  const clickOpenModal = () => {
    let chs_data = Object.values(globalState.idxs.ch_list).filter(ch_item => ch_item.cid.startsWith('prime:') === false && ch_item.cid !== channel.cid);
    let parsed_chs_data = chs_data.map(itc => ({
      'cid': itc.cid,
      'id': itc.data.id,
      'type': itc.data.type,
      'name': getChannelName(itc, client.userID),
      'last_message_at': getEpochLastMessageAt(itc)
    })).sort(sort_obj_lastMessageAt);
    let dispatchPayload = {
      message: {
        text: message.text,
        attachments: message.attachments,
        id: message.id,
        author: message.user.name || message.user.id || '',
        ch_id: channel.data.id,
        ch_type: channel.data.type,
        ch_name: getChannelName(channel, client.userID),
        direct_members: getDirectMembers(channel)
      },
      channels_list: [...parsed_chs_data]
    };
    dispatch_modal({type: 'OPEN', payload: dispatchPayload});
  };
  const clickCloseModal = () => dispatch_modal({type: 'CLOSE'});
  const onChangeInput = (e) => dispatch_modal({type: 'UPDATE', payload: { input: e.target.value } });
  const clickForward = async (e) => {
    try {
      e.preventDefault();
      if (state_modal.data.selected === null || typeof state_modal.data.selected.id !== 'string' || typeof state_modal.data.selected.type !== 'string') dispatch_modal({type: 'ERROR'});
      let fwdMsg = {
        text: state_modal.data.message.text,
        attachments: state_modal.data.message.attachments,
        forwarded_msg: {
          id: state_modal.data.message.id,
          author: state_modal.data.message.author,
          ch_id: state_modal.data.message.ch_id,
          ch_type: state_modal.data.message.ch_type,
          ch_name: state_modal.data.message.ch_name,
          direct_members: state_modal.data.message.direct_members
        }
      };
      let ch_target = client.channel(state_modal.data.selected.type, state_modal.data.selected.id, {});
      if (Object.keys(client.activeChannels).includes(`${state_modal.data.selected.type}:${state_modal.data.selected.id}`) === false) await ch_target.watch({ messages: { limit: 25 } });
      await ch_target.sendMessage(fwdMsg);
      setGlobalState.drawer({switch: true, tab: state_modal.data.selected.type});
      setActiveChannel(ch_target);
      dispatch_modal({type: 'CLOSE'});
    } catch (error) {
      console.log(error)
      dispatch_modal({type: 'ERROR'});
    }
  };

  return (
    <>
    <IconButton size='small' color='primary' aria-label='forward message' onClick={clickOpenModal}>
      <Tooltip title='Forward Message' placement='bottom'><ShareIcon fontSize='xs'/></Tooltip>
    </IconButton>
    <Dialog fullWidth={true} maxWidth='sm' open={state_modal.open} TransitionComponent={Transition} onClose={clickCloseModal} aria-describedby='read-by-dialog'>
      <DialogTitle>{'Forward Message'}</DialogTitle>
      <DialogContent sx={{p:0, m:0, minHeight: 420}}>
        <Divider orientation='horizontal'/>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', m: 0, py: 2, px: 2}}>
          <TextField
            label='Search'
            size='small'
            variant='outlined'
            onChange={onChangeInput}
            fullWidth={true}
            value={state_modal.data.input}
            InputProps={{
              startAdornment: <InputAdornment position='start'><IconButton color='primary' onClick={() => dispatch_modal({type: 'UPDATE', payload: {input: ''}})} edge='start'>{state_modal.data.input === '' ? <SearchIcon /> : <ClearIcon />}</IconButton></InputAdornment>
            }}
          />
          <Box sx={{ flex: '1 1 auto', minWidth: '8px' }} />
          <Box sx={{ minWidth: '56px', textAlign: 'center', mr: 1}}>
            <Chip size='small' label={'Group'} color='primary' variant={state_modal.data.filter === 'team' ? 'filled' : 'outlined'} onClick={() => dispatch_modal({type: 'UPDATE-FILTER', payload: {filter: 'team'}})}/>
          </Box>
          <Box sx={{ minWidth: '56px', textAlign: 'center'}}>
            <Chip size='small' label={'Direct'} color='primary' variant={state_modal.data.filter === 'direct' ? 'filled' : 'outlined'} onClick={() => dispatch_modal({type: 'UPDATE-FILTER', payload: {filter: 'direct'}})}/>
          </Box>
        </Box>
        <Divider orientation='horizontal'/>
        {/* LIST HERE */}
        <FixedSizeList height={300} width={'100%'} itemSize={60} itemData={state_modal.data.channels_filtered} itemCount={state_modal.data.channels_filtered.length} overscanCount={4}>
          {(listProps) => {
            const { data, index, style } = listProps;
            const item = data[index];
            const itemKey = item.cid;
            const isSelected = state_modal.data.selected !== null && state_modal.data.selected.cid === itemKey;
            const toggleSelectChannel = () => {
              if (isSelected === true) dispatch_modal({type: 'UPDATE', payload: {selected: null}})
              else dispatch_modal({type: 'UPDATE', payload: {selected: item}})
            };
            return (
              <>
                <ListItem style={style} key={itemKey} component='div' disablePadding>
                  <ListItemButton role={undefined} sx={{height: '100%'}} onClick={toggleSelectChannel} selected={isSelected} /*disabled={}*/>
                    <ListItemIcon sx={{minWidth: '36px', width: '36px'}}>
                      <Checkbox edge='start' checked={isSelected} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': itemKey }}/>
                    </ListItemIcon>
                    <ListItemIcon sx={{minWidth: '56px', width: '56px', mr: 2}}>
                      { item.type === 'team' && <Chip size='small' label={'Group'} color='primary' variant={'outlined'} /> } 
                      { item.type === 'direct' && <Chip size='small' label={'Direct'} color='primary' variant={'outlined'} /> }
                    </ListItemIcon>
                    {/* <ListItemText
                      id='driverUnits'
                      sx={{...listItemSX, width: '45%'}}
                      primary={item.driverUnits.sort((a, b) => {
                          if (a > b) return -1;
                          else if (b < a) return 1;
                          else return 0;
                        }).map((unit, index) => <Chip
                        key={item.cid+unit+index} label={unit} size='small' color='primary' sx={{ml: index === 0 ? 0 : 0.2}}
                        onClick={(e) => {
                          e.preventDefault();
                          setSearchFilters(prev => ({...prev, inputSearch: prev.inputSearch === unit ? '' : unit}));
                          e.stopPropagation();
                        }}
                        variant={item.driverUnits_primary.includes(unit) === true ? 'filled' : 'outlined'}
                        />)}
                      /> */}
                    <ListItemText /*sx={listItemSX} */ primary={<Typography fontWeight={400}>{item.name}</Typography>}/>
                    {/* <ListItemText sx={listItemSX} primary={<Typography fontWeight={400}>{item.phoneNumber}</Typography>}/> */}
                  </ListItemButton>
                </ListItem>
              </>
            );
          }}
        </FixedSizeList>
        <Divider orientation='horizontal'/>
        <Box sx={{ height: '20px', textAlign: 'center'}}>
          { state_modal.data.selected !== null
          && <><Typography color={'info.main'} component='div' variant='body1' sx={{fontStyle: 'italic', textAlign: 'center', background: 'rgba(0, 154, 201, 0.125)', py: 1 }}>
            {state_modal.data.selected.type === 'team' && <Chip size='small' label={'Group'} color='primary' variant={'outlined'} sx={{mr:1}} />}
            {state_modal.data.selected.type === 'direct' && <Chip size='small' label={'Direct'} color='primary' variant={'outlined'} sx={{mr:1}} />}
            {`${state_modal.data.selected.name}`}
            </Typography>
            <Divider orientation='horizontal'/>
            </>
          }
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', flexDirection: 'row', m: 0, py: 2, px: 2}}>
        {/* { state_modal.error === false && <Typography color={'error.main'} component='div' variant='body1' sx={{fontStyle: 'italic', textAlign: 'center' }}>{`Unexpected error`}</Typography>} */}
        <Box sx={{ flex: '1 1 auto' }} />
        { state_modal.error === true && <Button size='small' variant='outlined' endIcon={<WarningIcon />} color={'error'}>{'Error'}</Button> }
        { state_modal.data.selected !== null && state_modal.error === false && <Button size='small' variant='outlined' endIcon={<SendIcon />} color={'primary'} onClick={clickForward}>{'Forward'}</Button> }
        <Button size='small' variant='text' onClick={clickCloseModal}>{'Close'}</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};